import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.nav `
  display: block;
  color: ${cssVar('fgColor')};
  user-select: none;
`;
const List = styled.ul `
  display: flex;
  align-items: center;
`;
const Item = styled.li `
  display: flex;
  align-items: center;
  ${fonts.workSans.light};
  font-size: 12px;
  letter-spacing: normal;
  line-height: 18px;

  @media ${from(Device.TabletLarge)} {
    font-size: 17px;
    line-height: 20px;
  }

  & + & {
    &::before {
      content: '/';
      margin: 0 4px;
    }
  }
`;
const Link = styled.a `
  display: block;
  color: currentColor;
  text-decoration: none;
  text-underline-position: under;

  a& {
    &:focus,
    &:hover {
      outline: none;
      text-decoration: underline;
    }
  }

  span& {
    cursor: default;
  }
`;
export default {
    Container,
    Item,
    Link,
    List,
};
